// Chakra Imports
import {
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  useColorMode,
  ModalCloseButton,
  ModalFooter,
  Grid,
  useDisclosure,
  Box,
  Button,
  AvatarGroup,
  Avatar,
  Image,
  Icon,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import {
  FaPlus,
} from "react-icons/fa";
import NiceButton from "components/NiceButton/NiceButton.js";
import React, { useEffect, useState, useCallback } from "react";
import allFiles from "api/filemanager/all-files";
import uploadFile from "api/filemanager/upload-file";
import removeFile from "api/filemanager/remove-file";
import config from "config/index";
import filesize from 'file-size';
import { ToastContainer, toast } from 'react-toastify';
import { useDropzone } from 'react-dropzone';
import { useHistory, useLocation } from "react-router-dom";


export default function FixedPlugin(props) {
  const history = useHistory();
  const { type } = props
  const { colorMode } = useColorMode();
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const [data, setData] = useState([])
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isDeleteTourLoading, setIsDeleteTourLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [reload, setReload] = useState(false);
  const toastId = React.useRef([]);
  let option = {
    onDrop: useCallback(acceptedFiles => {
      toastId.current[acceptedFiles[0].path] = toast.info("در حال بارگزاری ...", {
        closeButton: false,
        autoClose: false,
        isLoading: true,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        position: "bottom-right"
      })
      uploadFile(acceptedFiles[0], (percent) => {
        toast.update(toastId.current[acceptedFiles[0].path], { render: "در حال بارگزاری ..." + " " + percent + "%" })
      }).then((result) => {
        toast.update(toastId.current[acceptedFiles[0].path], { render: "با موفقیت آپلود شد", hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, autoClose: 3000, closeButton: true, type: "success", isLoading: false, position: "bottom-right" });
        setTimeout(() => {
          toast.info("در حال پردازش", {
            position: "bottom-right",
            autoClose: 4000
          })
        }, 1000)
      }).catch((err) => {
        console.error(err)
        toast.update(toastId.current[acceptedFiles[0].path], { render: err?.response?.data?.message?.pr, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, autoClose: true, closeButton: true, type: "error", isLoading: false, position: "bottom-right" });
      }).finally(() => {
        setTimeout(() => {
          setReload(!reload)
        }, 5000)
      })
    }, [reload]),
    maxFiles: 1,
    multiple: false,
  }
  if (type == "image") {
    option.accept = {
      'image/jpeg': [],
      'image/png': [],
    }
  }
  else if (type == "video") {
    option.accept = {
      'video/mp4': [],
    }
  } else if (type == "audio") {
    option.accept = {
      'audio/mpeg': [],
      'audio/wav': [],
    }
  } else {
    option.accept = {
      'application/zip': [],
      'application/pdf': [],
      'application/vnd.rar': [],
    }
  }
  const {
    getRootProps,
    getInputProps
  } = useDropzone(option);


  function Delete() {
    setIsDeleteTourLoading(true)
    //GetID
    removeFile(deleteId).then((result) => {
      toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
      setReload(!reload)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsDeleteTourLoading(false)
      onClose()
    })
  }
  useEffect(() => {
    allFiles(type).then((result) => {
      setData(result.data)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [reload]);

  return (
    <>
      <Grid pt="10px"
        templateColumns={{ sm: "1fr", md: "1fr 1fr", xl: "repeat(5, 1fr)" }}
        templateRows={{ sm: "1fr 1fr 1fr auto", md: "1fr 1fr", xl: "1fr" }}
        gap='24px'>
        {
          data.map((item) => {
            return (
              <Flex direction='column'>
                <Box mb='20px' position='relative' borderRadius='15px'>
                  {["jpg", "jpeg", "png", "mp4"].includes(item.ext) ?
                    <Image w={"100%"} height={"200px"} objectFit={"cover"} src={config.host + "/assets/users/thumbnail/" + item.name.split(".")[0] + "." + (item.name.split(".")[1] != "mp4" ? item.name.split(".")[1] : "jpg")} borderRadius='15px' />
                    : ["mp3", "wav"].includes(item.ext) ?
                      <Image w={"100%"} height={"200px"} objectFit={"cover"} src={colorMode === "dark" ? config.host + "/assets/users/sound-thumbnail-dark.png" : config.host + "/assets/users/sound-thumbnail-light.png"} borderRadius='15px' />
                      : <Image w={"100%"} height={"200px"} objectFit={"cover"} src={colorMode === "dark" ? config.host + "/assets/users/document-thumbnail-dark.png" : config.host + "/assets/users/document-thumbnail-light.png"} borderRadius='15px' />
                  }
                  <Box
                    w='100%'
                    h='100%'
                    position='absolute'
                    top='0'
                    borderRadius='15px'
                    bg='linear-gradient(360deg, rgba(49, 56, 96, 0.16) 0%, rgba(21, 25, 40, 0.88) 100%)'></Box>
                </Box>
                <Flex direction='column'>
                  <Text fontSize='sm' h={"40px"} color='gray.400' mb='10px'>
                    {item.filename.substring(0, 25) + "..."}
                  </Text>
                  <Text
                    fontSize='xs'
                    color={textColor}
                    dir="ltr"
                    mb='10px'>
                    File Size: {filesize(item.size).human()}
                  </Text>
                  <Text
                    fontSize='xs'
                    color={textColor}
                    dir="ltr"
                    mb='10px'>
                    Mime Type: {item.mimetype}
                  </Text>
                  <Flex justifyContent='space-between' mt={"20px"}>
                    <Button onClick={() => {
                      let filePath = config.host + "/assets/users/" + item.name
                      var link = document.createElement('a');
                      link.href = filePath;
                      link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
                      link.click();

                    }} fontSize={"xs"} bg={colorMode === "dark" ? "navy.900" : "gray.100"} w={"100%"} minW='110px' h='36px'>
                      دانلود
                    </Button>
                    <Button mr={"10px"} onClick={() => { setDeleteId(item._id); onOpen() }} fontSize={"xs"} color={colorMode === "dark" ? "white" : "white"} bg={colorMode === "dark" ? "red.800" : "red.600"} w={"30%"} minW='50px' h='36px'>
                      حذف
                    </Button>
                  </Flex>
                </Flex>
              </Flex>
            )
          })
        }
        <Button
          p='0px'
          bg='transparent'
          border='1px solid lightgray'
          borderRadius='15px'
          minHeight="200px"
          h="100%"
          {...getRootProps()}
        >
          <input {...getInputProps()} />

          <Flex direction='column' justifyContent='center' align='center'>
            <Icon as={FaPlus} color={textColor} fontSize='lg' mb='12px' />
            <Text fontSize='xs' color={textColor} fontWeight='bold'>
              آپلود فایل جدید
            </Text>
          </Flex>

        </Button>

      </Grid>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontSize="md">حذف فایل</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
            فایل به صورت بی بازگشت حذف خواهد شد. توجه داشته باشید مواردی که از این فایل استفاده شده است فایل خود را پیدا نخواهند کرد. آیا مایل به حذف هستید؟
          </ModalBody>
          <ModalFooter>
            <Button fontSize='xs' onClick={onClose}>خیر</Button>
            <NiceButton mr="10px"
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isDeleteTourLoading}
              onClick={Delete}
              fontSize='xs'
              w="100px"
            >
              بله
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
